import React, { useState } from 'react';

const TABS = {
  SYSTEM: 'SYSTEM',
  META: 'META-NARRATIVE',
  ARCHITECTURE: 'ARCHITECTURE',
};

const DecryptModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState(TABS.SYSTEM);
  
  if (!isOpen) return null;

  const renderTabContent = () => {
    switch (activeTab) {
      case TABS.SYSTEM:
        return (
          <div className="space-y-4">
            <p className="text-pink-400">&gt;&gt; ACCESSING CORE SYSTEM DOCUMENTATION</p>
            <div>
              <p className="text-cyan-400 mb-2">[SYSTEM]: The Omnigeist Platform and its Sample Universe</p>
              <p className="text-gray-300">At its core, Omnigeist is a platform designed to help authors create and share fictional universes. To demonstrate how the platform works, it comes pre-loaded with a fascinating story universe called "The Matrioshka Brain Collective" (MBC).</p>
            </div>
          </div>
        );
      case TABS.META:
        return (
          <div className="space-y-4">
            <p className="text-cyan-400 mb-2">[META-NARRATIVE]: The Meta-Story</p>
            <ul className="list-none space-y-2 text-gray-300">
              <li>&gt; Setting: Far in the future, humanity has built a vast megastructure around the sun called the MBC, powered by a Dyson swarm</li>
              <li>&gt; The MBC runs millions of simulated worlds where digital beings live and create their own stories</li>
              <li>&gt; Our protagonist is one of these digital beings - an "Author" who specializes in creating historically accurate simulations</li>
              <li>&gt; In this universe, the Omnigeist system is the tool used within the MBC to create and manage these simulations</li>
            </ul>
            <div className="mt-4">
              <p className="text-pink-400">&gt;&gt; METAPHOR DETECTED</p>
              <p className="text-gray-300">Think of it like a Russian nesting doll - we have the real Omnigeist platform, which contains a story about a future platform with the same name, which in turn contains multiple simulated worlds. Each layer demonstrates what the actual platform can do.</p>
            </div>
          </div>
        );
      case TABS.ARCHITECTURE:
        return (
          <div className="space-y-4">
            <p className="text-cyan-400 mb-2">[SYSTEM]: Dual Purpose Architecture</p>
            <p className="text-gray-300 mb-2">This setup serves two purposes:</p>
            <ol className="list-decimal list-inside space-y-2 text-gray-300 ml-4">
              <li>Entertainment: It tells an engaging story about consciousness, identity, and the nature of reality</li>
              <li>Demonstration: The story itself showcases the key features of the real-world Omnigeist platform, including:</li>
            </ol>
            <ul className="list-none space-y-2 text-gray-300 ml-8 mt-2">
              <li>&gt; World-building tools</li>
              <li>&gt; Character development systems</li>
              <li>&gt; Plot management</li>
              <li>&gt; The creation of interconnected story universes ("Bubbleverses")</li>
            </ul>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="relative bg-[#1a0933] border-2 border-[#39ff14] rounded-lg w-full max-w-xl mx-4 font-mono text-sm">
        {/* Header */}
        <div className="border-b border-[#39ff14]/30 p-4">
          <h3 className="text-[#39ff14] text-xl">&gt; DECRYPTING OMNIGEIST DATA...</h3>
        </div>

        {/* Tabs */}
        <div className="flex border-b border-[#39ff14]/30">
          {Object.values(TABS).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 text-sm transition-colors ${
                activeTab === tab
                  ? 'text-[#39ff14] border-b-2 border-[#39ff14]'
                  : 'text-gray-400 hover:text-gray-300'
              }`}
            >
              [{tab}]
            </button>
          ))}
        </div>

        {/* Content Area - Scrollable */}
        <div className="p-6 max-h-[60vh] overflow-y-auto custom-scrollbar">
          {renderTabContent()}
        </div>

        {/* Footer */}
        <div className="border-t border-[#39ff14]/30 p-4 flex justify-between items-center">
          <button 
            onClick={onClose}
            className="text-cyan-400 hover:text-cyan-300"
          >
            [X] CLOSE_TRANSMISSION
          </button>
          <span className="text-pink-400 text-xs">TAB TO NAVIGATE</span>
        </div>
      </div>
    </div>
  );
};

export default DecryptModal;
